import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const ListDropdowntWrapper = styled.div`
  .list-select {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    height: 40px;
    border: 1px solid ${colors.grey444};
    border-radius: 8px;
    padding-inline: 16px 8px;
    cursor: pointer;

    &--sm {
      height: 32px;
      padding-inline: 8px;
    }

    &__left {
      display: flex;
      align-items: center;
    }

    &__remove {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 20px;
      height: 20px;
      border-radius: 50%;

      &:hover {
        background-color: ${colors.grey444};
      }
    }

    &__arrow {
      display: inline-flex;
    }
  }
`;
